import axios from 'axios'

/**
 * 好友相关API
 */
export default {
  /**
   * 获取好友列表
   */
  getFriendList(userId) {
    return axios({
      url: '/message/api/v1/friend/list',
      method: 'get',
      params: { userId }
    })
  },

  /**
   * 发送好友申请
   */
  sendApply(fromUserId, toUserId, reason) {
    return axios({
      url: '/message/api/v1/friend/apply',
      method: 'post',
      params: { fromUserId, toUserId, reason }
    })
  },

  /**
   * 处理好友申请
   */
  handleApply(applyId, userId, accept) {
    return axios({
      url: '/message/api/v1/friend/handle',
      method: 'post',
      params: { applyId, userId, accept }
    })
  },

  /**
   * 获取收到的申请列表
   */
  getReceivedApplies(userId) {
    return axios({
      url: '/message/api/v1/friend/applies/received',
      method: 'get',
      params: { userId }
    })
  },

  /**
   * 获取发出的申请列表
   */
  getSentApplies(userId) {
    return axios({
      url: '/message/api/v1/friend/applies/sent',
      method: 'get',
      params: { userId }
    })
  },

  /**
   * 删除好友
   */
  removeFriend(userId, friendId) {
    return axios({
      url: '/message/api/v1/friend/remove',
      method: 'delete',
      params: { userId, friendId }
    })
  },

  /**
   * 判断是否为好友
   */
  isFriend(userId, targetUserId) {
    return axios({
      url: '/message/api/v1/friend/check',
      method: 'get',
      params: { userId, targetUserId }
    })
  }
}
